import { createAction } from '@reduxjs/toolkit';
import { ActionTypes } from './types';
import slice from './slice';

const changeLanguage = createAction(
  ActionTypes.CHANGE_LANGUAGE,
  (payload: any) => ({
    payload: { lang: payload },
  })
);

export default { ...slice?.actions, changeLanguage };